import * as IoC from 'typescript-ioc';
import { ContextExecutionParams, EventParams } from '../index';
import { IRouter } from '../../../infrastructure/router';
import { ExecutionContext } from '../execution-context';

export class EventExecutionContext extends ExecutionContext<EventParams> {
    private readonly routingService: IRouter<EventParams> = IoC.Container.get(IRouter);

    private get currentParams(): EventParams {
        return this.routingService.router?.getState()?.params ?? {};
    }

    private get accountId(): number | null {
        return this.currentParams.accountId ? Number(this.currentParams.accountId) : null;
    }
    private get eventId(): number | null {
        return this.currentParams.eventId ? Number(this.currentParams.eventId) : null;
    }

    /**
     * Treat ExecutionContext as valid context when required event params are present.
     */
    public isValid(): boolean { return !!(this.accountId && this.eventId); }

    public getContextParams(): ContextExecutionParams<EventParams> {
        return this.isValid()
            ? { accountId: this.accountId, eventId: this.eventId }
            : {} as EventParams;
    }
}
